/* Sorting happens on the collection endpoint, before Shopify paginates the catalog. */
if (!customElements.get('ruyi-new-products')) {
  customElements.define('ruyi-new-products', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-products-content]');
      this.error = this.querySelector('[data-products-error]');
      this.retry = this.querySelector('[data-products-retry]');
      this.onRetry = () => this.loadProducts();
      this.retry.addEventListener('click', this.onRetry);
      this.onSliderClick = (event) => {
        const button = event.target.closest('[data-products-direction]');
        if (!button || !this.grid) return;
        const count = Math.max(1, Math.round(this.grid.clientWidth / this.itemStep()));
        this.grid.scrollBy({ left: Number(button.dataset.productsDirection) * count * this.itemStep(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.addEventListener('click', this.onSliderClick);
      if (this.content.dataset.sorted !== 'true') this.loadProducts();
      else this.setupSlider();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.retry?.removeEventListener('click', this.onRetry);
      this.removeEventListener('click', this.onSliderClick);
      this.grid?.removeEventListener('scroll', this.onSliderScroll);
      this.resizeObserver?.disconnect();
    }

    itemStep() {
      const item = this.grid?.querySelector('li');
      return item ? item.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.grid).columnGap) || 0) : 1;
    }

    setupSlider() {
      this.grid?.removeEventListener('scroll', this.onSliderScroll);
      this.resizeObserver?.disconnect();
      this.grid = this.content.querySelector('.ruyi-products__grid');
      this.controls = this.querySelector('[data-products-controls]');
      if (!this.grid || !this.controls) return;
      this.grid.id = this.id + '-slider';
      this.grid.tabIndex = 0;
      this.grid.setAttribute('aria-label', 'Produse noi — derulează pentru mai multe produse');
      this.controls.querySelectorAll('button').forEach(button => button.setAttribute('aria-controls', this.grid.id));
      this.onSliderScroll = () => this.updateSlider();
      this.grid.addEventListener('scroll', this.onSliderScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateSlider());
      this.resizeObserver.observe(this.grid);
      this.updateSlider();
    }

    updateSlider() {
      const total = this.grid.children.length;
      const step = this.itemStep();
      const visible = Math.max(1, Math.round(this.grid.clientWidth / step));
      const first = Math.min(total, Math.round(this.grid.scrollLeft / step) + 1);
      this.controls.hidden = total <= visible;
      this.controls.querySelector('[data-products-direction="-1"]').disabled = this.grid.scrollLeft <= 2;
      this.controls.querySelector('[data-products-direction="1"]').disabled = this.grid.scrollLeft >= this.grid.scrollWidth - this.grid.clientWidth - 2;
      this.controls.querySelector('[data-products-range]').textContent = first + '–' + Math.min(total, first + visible - 1) + ' din ' + total;
    }

    async loadProducts() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 15000);
      this.error.hidden = true;
      this.content.hidden = false;
      this.content.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.dataset.sourceUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid collection origin');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('sort_by', 'created-descending');
        url.searchParams.delete('page');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Products unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.getElementById(this.id)?.querySelector('[data-products-content][data-sorted="true"]');
        if (!content) throw new Error('Sorted products missing');
        if (!this.isConnected || this.controller !== controller) return;
        this.content.innerHTML = content.innerHTML;
        this.content.dataset.sorted = 'true';
        this.dataset.sorted = 'true';
        this.setupSlider();
      } catch (error) {
        if (!this.isConnected || this.controller !== controller) return;
        this.content.hidden = true;
        this.error.hidden = false;
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) this.content.setAttribute('aria-busy', 'false');
      }
    }
  });
}
